module.exports = __webpack_public_path__ + "static/img/an.93bd2d9e.gif";